<style lang="scss" scoped>
$leftWidth: 220px;
.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}

.el-checkbox--upload {
  position: absolute;
  left: 100px;
  top: 0;
  display: block;
}
</style>
<template>
  <div>
    <div class="content-part">
      <!--<div class="content-left">-->
      <!--<h2 class="clearfix right-title" style="font-size: 16px">上传追溯码</h2>-->
      <!--</div>-->
      <div class="content-right min-gutter">
        <h3>{{ title }}</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item label="货品" prop="goodsId">
              <el-select placeholder="请输入名称搜索货品" v-model="form.goodsId" filterable remote
                         :remote-method="queryAllManageGoods" @change="goodsChange"
                         :clearable="true" popperClass="custom-select" @click.native="queryAllManageGoods('')">
                <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in manageGoods">
                  <manage-goods-option :optionItem="item"/>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属单位" prop="orgId" v-show="platform">
              <el-select filterable placeholder="请输入名称搜所属单位" remote :remote-method="queryPermUpAllFactory"
                         :clearable="true" v-model="form.orgId"
                         popperClass="good-selects">
                <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in allOrgList">
                  <div style="overflow: hidden">
                    <span class="pull-left" style="clear: right">{{ org.name }}</span>
                  </div>
                  <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{ org.manufacturerCode }}
                      </span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label-width="0" v-show="form.goodsId">-->
            <!--              <oms-col label="规格" :value="currentGoods.specifications"/>-->
            <!--              <oms-col label="追溯码商品编号" :value="currentGoods.goodsTrackNo" :is-show="true"/>-->
            <!--            </el-form-item>-->
            <el-form-item label="产品名称" prop="productName">
              <el-input clearable v-model="form.productName" placeholder="请输入产品名称"></el-input>
            </el-form-item>
            <el-form-item label="产品编码" prop="productCode">
              <el-input clearable v-model="form.productCode" placeholder="请输入产品编码" :maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="子类编码" prop="productSubclassCode">
              <el-input clearable v-model="form.productSubclassCode" placeholder="请输入子类编码" :maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="剂型" prop="productDosage">
              <el-input clearable v-model="form.productDosage" placeholder="请输入剂型"></el-input>
            </el-form-item>
            <el-form-item label="剂型规格" prop="productSpecification">
              <el-input clearable v-model="form.productSpecification" placeholder="请输入剂型规格"></el-input>
            </el-form-item>
            <el-form-item label="包装规格" prop="productPackingSpecification">
              <el-input clearable v-model="form.productPackingSpecification" placeholder="请输入包装规格"></el-input>
            </el-form-item>
            <el-form-item label="包装单位" prop="productPackingUnit">
              <el-input clearable v-model="form.productPackingUnit" placeholder="请输入包装单位"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="productRemark">
              <el-input type="textarea" clearable v-model="form.productRemark" placeholder="请输入备注"></el-input>
            </el-form-item>
            <!--            <el-form-item label="上传模式">-->
            <!--              <el-checkbox v-model="isChecked">覆盖原有数据</el-checkbox>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="上传追溯码">-->
            <!--              <oms-upload-relation uploadUrl="/qingstor/code/pre" deleteUrl="/code-upload/file"-->
            <!--                                   :fileList="fileList" :formData="{objectType:'traceCodeByOrg',-->
            <!--                                   type: isChecked ? '1' : undefined}" uploadTip="只能上传xml文件" accept="xml"-->
            <!--                                   @change="changeFiles" @isProgress="onUploadProgress"-->
            <!--                                   :clearUploadFiles="clearUploadFiles"-->
            <!--                                   @refreshCodes="setIsUploading(true)"></oms-upload-relation>-->
            <!--              <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>-->
            <!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing"
              >保存
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http, goodsManage} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import dosageSelectMixin from '@/mixins/dosageSelectMixin';
import platform from "@/components/goods/platform";

export default {
  name: 'goodsForm',
  props: {
    defaultIndex: Number,
    title: String,
    platform: {
      type: Boolean,
      default: false
    }
  },
  mixins: [methodsMixin, dosageSelectMixin],
  data() {
    return {
      form: {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      },
      orgRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: [{required: true, message: '请输入产品编码', trigger: 'change'}, {min: 1, max: 18, message: '产品编码最大长度为18位', trigger: 'blur'}],
        productName: {required: true, message: '请输入产品名称', trigger: 'change'},
        productSubclassCode: [{required: true, message: '请输入子类编码', trigger: 'change'}, {min: 1, max: 18, message: '子类编码长度最大为18位', trigger: 'blur'}],
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      platformRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        orgId: {required: true, message: '请选择所属单位', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productName: {required: true, message: '请输入产品名称', trigger: 'change'},
        productCode: [{required: true, message: '请输入产品编码', trigger: 'change'}, {min: 1, max: 18, message: '产品编码最大长度为18位', trigger: 'blur'}],
        productSubclassCode: [{required: true, message: '请输入子类编码', trigger: 'change'}, {min: 1, max: 18, message: '子类编码长度最大为18位', trigger: 'blur'}],
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      // rules: {
      //   goodsId: {required: true, message: '请选择货品', trigger: 'change'},
      //   // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
      //   productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
      //   productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
      //   productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
      //   productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
      //   productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
      // },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    currentGoods() {
      return this.manageGoods.filter(f => f.id === this.form.goodsId)[0] || {};
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    },
    rules() {
      return this.platform ? this.platformRules : this.orgRules
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
    form(val) {
      if (!val.goodsId) return;
      this.handleSelectShow(val.goodsId, ()=>{});
    }
  },
  methods: {
    handleSelectShow(query, after) {
      let params = {};
      if (typeof query === 'object') {
        params = query;
      } else {
        let user = this.$store.state.user;
        if (!user.userCompanyAddress) return;
        params = {
          orgId: user.userCompanyAddress,
          deleteFlag: false,
          // keyWord: query,
          goodsId: query,
          auditStatus: '1'
        };
      }
      this.$http.get('/dhs-operation-goods', {params}).then(res => {
        this.manageGoods = res.data.list;
        after();
      });
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    goodsChange(val) {
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        // if (!this.currentGoods.goodsTrackNo) {
        //   return this.$notify.info({
        //     message: '追溯码商品编号为空，请联系管理员'
        //   });
        // }
        // if (!this.form.attachmentIdList.length) {
        //   this.$notify.info({
        //     message: '请选择追溯码文件'
        //   });
        //   return;
        // }
        // if (!this.isUploading) {
        //   this.$notify.info({
        //     message: '追溯码文件还没有上传完成，请等待'
        //   });
        //   return;
        // }
        // this.form.type = 1;
        // this.form.model = this.isChecked ? 1 : 0;
        this.doing = true;
        if (!this.platform) {
          this.form.orgId = this.$store.state.user.userCompanyAddress;
        }
        if (this.title === '新增') {
          goodsManage.goodsAdd(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: this.$errHandler(e)
            });
            this.doing = false;
          });
        } else {
          goodsManage.goodsEdit(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        }
      });
    }
  }
};
</script>
